import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CourseList from './views/CourseList.vue'
import CourseShow from './views/CourseShow.vue'
import Enroll from './views/Enroll.vue'
import Pay from './views/Pay.vue'
import Login from './views/Login.vue'
import Profile from './views/Profile.vue'
import Page from './views/Page.vue'
import EnrollHistory from './views/EnrollHistory.vue'
import EnrollReview from './views/EnrollReview.vue'
import BecomeLeader from './views/BecomeLeader.vue'
import ActivityList from './views/ActivityList.vue'
import ActivityShow from './views/ActivityShow.vue'
import LeaderList from './views/LeaderList.vue'
import LeaderShow from './views/LeaderShow.vue'
import RecommendLeader from './views/RecommendLeader.vue'
import LeaderLayout from './views/leader/LeaderLayout.vue'
import LeaderCourse from './views/leader/LeaderCourse.vue'
import LeaderEnroll from './views/leader/LeaderEnroll.vue'
import CoursePlan from './views/leader/CoursePlan.vue'
import CoursePlanApply from './views/leader/CoursePlanApply.vue'
import MyCourseBundle from './views/MyCourseBundle.vue'
import CourseBundleLog from './views/CourseBundleLog.vue'
import CourseBundleShow from './views/CourseBundleShow.vue'


import CurrentUser from "./untils/current-user";
import WechatAuth from "./untils/wechat-auth";
import WechatSdk from "./untils/wechat-sdk";

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
        path: '/courses',
        name: 'courses',
        component: CourseList,
        meta: {wxApi: ['getLocation', 'updateAppMessageShareData', 'updateTimelineShareData']},

    },
    {
        path: '/courses/:id',
        name: 'courses-show',
        component: CourseShow,
        meta: {wxApi: ['openLocation', 'updateAppMessageShareData', 'updateTimelineShareData']},
    },
      {
          path: '/activities',
          name: 'activities',
          component: ActivityList,
      },
      {
          path: '/activities/:id',
          name: 'activities-show',
          component: ActivityShow,
      },
      {
          path: '/leaders',
          name: 'leaders',
          component: LeaderList,
      },
      {
          path: '/leaders/:id',
          name: 'leaders-show',
          component: LeaderShow,
      },
      {
          path: '/page/:pageKey',
          name: 'page',
          component: Page,
      },
      {
          path: '/code',
          name: 'code',
          component: Pay,
          meta: {auth: true},
      },
      {
          path: '/login',
          name: 'login',
          component: Login,
      },
      {
          path: '/enroll',
          name: 'enroll',
          component: Enroll,
          meta: { auth: true },
      },
      {
          path: '/profile',
          name: 'profile',
          component: Profile,
          meta: {auth: true},
      },
      {
          path: '/enroll-history',
          name: 'enroll-history',
          component: EnrollHistory,
          meta: {auth: true},
      },
      {
          path: '/enroll-review/:enrollId',
          name: 'enroll-review',
          component: EnrollReview,
          meta: {auth: true},
      },
      {
          path: '/become-leader',
          name: 'become-leader',
          component: BecomeLeader,
          meta: {auth: true, referrer:true},
      },
      {
          path: '/recommend-leader',
          name: 'recommend-leader',
          component: RecommendLeader,
          meta: {auth: true, wxApi: ['updateAppMessageShareData', 'updateTimelineShareData']},

      },
      {
          path: '/leader',
          name: 'leader',
          component: LeaderLayout,
          meta: {auth: true},
          children:[
              {path: '/',component: CoursePlan,},
              {path: 'course-plans',name: 'course-plan',component: CoursePlan,},
              {path: 'course-plans/create',name: 'course-plan-create',component: CoursePlanApply,},
              {path: 'courses',name: 'leader-courses',component: LeaderCourse,},
              {path: 'enrolls',name: 'leader-enrolls',component: LeaderEnroll,},
          ]
      },
      {
          path: '/my-course-bundle',
          name: 'my-course-bundle',
          component: MyCourseBundle,
          meta: {auth: true},
      },
      {
          path: '/course-bundle-log',
          name: 'course-bundle-log',
          component: CourseBundleLog,
          meta: {auth: true},
      },
      {
          path: '/course-bundle/:id',
          name: 'course-bundle-show',
          component: CourseBundleShow,
          meta: {auth: true},
      },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
});

const body = document.querySelector('body');
const currentUser = CurrentUser.getInstance();
const wechatAuth = new WechatAuth();
router.beforeEach((to, from, next) => {
    const {meta, name} = to;
    setReferrer(to);
    setBodyClass(name);
    if(meta.auth && !currentUser.getToken()) {
        console.log('go wechat auth', to);
        wechatAuth.auth(to.fullPath);
    } else {
        next();
    }
});


const wechatSdk = new WechatSdk();
router.afterEach((to, from) => {
    const {meta} = to;
    if(meta.wxApi) {
        wechatSdk.config(meta.wxApi, to.fullPath);
    }
});

function setReferrer(to) {
    const {query, meta} = to;
    if(!meta.referrer)
        return true;

    if(query.referrer) {
        console.log('set referrer', query.referrer);
        localStorage.setItem("referrer", query.referrer);
    }
}

function setBodyClass(name) {

    // let className = "page-" + name;
    // if(bodyClass) {
    //     className += ' ' + bodyClass;
    // }
    body.className = "page-" + name;
}

export default router;
